import gql from 'graphql-tag'

export const CORRESPONDENCE_EMAIL_START_PROCESSING_MUTATION = gql`
    mutation correspondenceEmailStartProcessing(
        $id: ID!
    ) {
        correspondenceEmailStartProcessing(
            id: $id
        ) {
            id
        }
    }
`
